export const POPUP_MENU_CONTENT_MIN_RIGHT_INDENT = 20;
export const BASE_CLASS_NAME = 'ui-popup-menu';
